import React from 'react';
import katex from 'katex';

const convert = function(convert){
    return convert.replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');
    //return document.createElement("span").innerText;
};

function renderKatexAndReturnElement(string) {

    let target = document.createElement('div')
    let stringToConvert = convert(string)

    if(!stringToConvert) return target.innerHTML

    // target.style = 'display: flex; flex-direction: row'

    let pointer = 0
    let latexExpression = false
    let startPointerCurrentLatexExpression = 0
    let endPointerCurrentLatexExpression = 0
    let currentString = ''

    function appendToTarget(string) {
        let div = document.createElement('div')
        div.innerHTML = string

        target.append(div)
    }

    // lets find , and replace on original string

    while(pointer < stringToConvert.length) {
        if(!latexExpression) {
            const tag = stringToConvert.substring(pointer, pointer + 7)
            // console.log(tag)
            if(tag === '<latex>') {
                // we found latex
                startPointerCurrentLatexExpression = pointer
                pointer += 6
                latexExpression = true
            }
        } else {
            const tag = stringToConvert.substring(pointer, pointer + 8)

            if(tag == '</latex>') {
                endPointerCurrentLatexExpression = pointer
                let element1 = document.createElement('div')
                // element1.style = 'margin-left: 4px; margin-right: 4px;'
                katex.render(currentString, element1, {
                    throwOnError: false,
                    displayMode: true,
                });

                latexExpression = false
                currentString = ''

                pointer += 8

                stringToConvert = `${stringToConvert.slice(0, startPointerCurrentLatexExpression)}${element1.innerHTML}${stringToConvert.slice(endPointerCurrentLatexExpression)}`

                // target.append(element1)

            } else {
                currentString += stringToConvert[pointer]
            }
        }

        pointer++

    }

    appendToTarget(stringToConvert)

    return target.innerHTML;
}


export default function Latex({message}) {
    return (
        <div dangerouslySetInnerHTML={{ __html: renderKatexAndReturnElement(message) }} />
    )
}
